"use client";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Typography } from "@/components/ui/typography";
import { toast } from "sonner";

const Faq = () => {
  const code = "2220278200";

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    toast.success("Код амжилттай хуулсан!"); // Show a success toast
  };

  return (
    <div className="flex flex-col gap-5">
      <Typography variant="title">Түгээмэл асуугддаг асуултууд</Typography>
      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="item-1">
          <AccordionTrigger>
            MOT-д хэрхэн бүртгүүлэх вэ? Насанд хүрсэн байх хэрэгтэй юу?
          </AccordionTrigger>
          <AccordionContent>
            <a
              href="https://my.motforex.com/auth?tab=signup&contractNo=2220278200"
              target="_blank"
              className="font-semibold text-white"
            >
              https://my.motforex.com/auth
            </a>{" "}
            link-ээр ороод бүртгэл үүсгээрэй.
            <br />
            <Typography>
              Заавал 18 нас хүрсэн байх хэрэгтэй эрх зүйн бүрэн чадамжгүй буюу
              18-аас доош настай бол боломжгүй. Та бүртгэл үүсгэхдээ{" "}
              <span
                className="font-semibold text-primary cursor-pointer underline"
                onClick={handleCopy}
                title="Click to copy"
              >
                {code}
              </span>{" "}
              партнер кодыг ашиглаарай.
            </Typography>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-2">
          <AccordionTrigger>
            Арилжаа яаж хийх вэ? Forex сурмаар байна.
          </AccordionTrigger>
          <AccordionContent>
            Арилжаа хийхдээ та зөвхөн манай Telegram signal group-д орно дагахад хангалттай.
            Хэрвээ өөрөө эхнээс нь арилжаа хийж сурмаар байвал манай сургалтад хамрагдах боломжтой.
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-4">
          <AccordionTrigger>
            Forex эрсдэлтэй юу? Forex гэж юу вэ?
          </AccordionTrigger>
          <AccordionContent>
            Мэдээж эрсдэлгүй зах зээл гэж үгүй. Аливаа арилжаа 100% ашигтай явах боломж энэ дэлхий дээр байхгүй тул хувь хүн өөрөө өөрийнхөө эрсдэлээ зөв тооцоолж арилжаанд орох нь зөв. Forex гэдэг нь Foreign Exchange буюу нэг валютыг нөгөө валютаар солих гэсэн утгатай бөгөөд аливаа улсын мөнгөн тэмдэгтийг  өөр улсын  мөнгөн тэмдэгтээр худалдаалж үнийн хөдөлгөөнөөс ашиг олох дэлхий нийтийг хамарсан валютын зах зээл юм.
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-5">
          <AccordionTrigger>
            Telegram дээр явж байгаа Signal ойлгохгүй байна. Жишээ: TP, SL,
            Sell, Buy.
          </AccordionTrigger>
          <AccordionContent>
            TP гэдэг нь take profit буюу ашиг авах гэсэн үг
            SL гэдэг нь stop loss буюу алдагдлаа автоматаар зогсоох гэсэн үг
            BUY гэдэг нь аливаа арилжаалах зүйлээ худалдаж авахыг хэлнэ
            SELL гэдэг нь аливаа арилжаалах зүйлээ зарахыг хэлнэ
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-6">
          <AccordionTrigger>
            Meta 5 ашиглаж арилжаа нээж, хааж, захиалга өгч чадахгүй байна.
            Дансаа холбож чадахгүй байна
          </AccordionTrigger>
          <AccordionContent>
            Meta5 гэсэн платформ татаж авна. Android утастай бол Play store, Iphone утастай бол App store-оос (Суурин компьютер болон Laptop мөн адил) Meta5 гэж хайн бичиж татаж авч суулгана. Add Account-руу орж Search хэсэг дээр MOT Forex LLC гэж бичнэ хайж ороод MOTForex-Live-1 сервер сонгон нэвтрэх нэр нууц үг хэсэгт өөрийн дансны нэвтрэх нэр болон нууц үгээ хийнэ орно.
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default Faq;
